<template>
  <SideBarMobile />
  <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
    <SideBar />
  </div>
  <div class="notch-padding sticky top-0 z-40 lg:pl-72">
    <HeaderBar />
  </div>
</template>
